import { ReactNode } from 'react';
import { Box } from '@mui/material';

interface DrawerContentProps {
  children?: ReactNode;
}

export const DrawerContent: React.FC<DrawerContentProps> = ({ children }) => {
  return (
    <Box
      sx={{
        p: 2,
        overflowY: 'auto',
      }}
    >
      {children}
    </Box>
  );
};